const getModuleState = (state) => state.banners;

export const getAllBanners = (state) => getModuleState(state).allBanners;
export const getBannerBySlug = (state) => getModuleState(state).bannerById;